// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgChat0224 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M23 11.1206C22.6919 5.66079 18.2323 1.30128 12.6471 1.00004H12.0001C10.292 0.995718 8.60707 1.38583 7.08246 2.13863C3.35629 3.9591 1.00176 7.68097 1.00004 11.7531C0.995691 13.4228 1.39476 15.0699 2.16484 16.5603L1.00004 23L7.08246 21.3675C8.60707 22.1203 10.292 22.5104 12.0001 22.5061C16.1657 22.5045 19.973 20.2028 21.8353 16.5603C22.6054 15.0699 23.0045 13.4228 23 11.7531V11.1206ZM7.74092 3.48637C9.06323 2.83348 10.5195 2.4963 11.9963 2.50003L12.608 2.50004L12.8386 2.51632C17.5382 2.90038 21.2427 6.60374 21.5024 11.2051L21.5 11.7531C21.5038 13.1855 21.1623 14.5952 20.5027 15.8717C18.8953 19.0157 15.6052 21.0047 11.9995 21.0061C10.5195 21.0099 9.06324 20.6727 7.74656 20.0226L7.60383 19.9611C7.31335 19.8534 6.99528 19.8378 6.69362 19.9188L2.89704 20.937L3.64089 16.8273C3.69979 16.5017 3.64936 16.1657 3.49746 15.8717C2.83786 14.5952 2.49631 13.1855 2.50003 11.757C2.50151 8.25782 4.52658 5.05679 7.74092 3.48637Z"
				/>
			</Svg>
		);
	}
);
SvgChat0224.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgChat0224;
